export interface TimeDifference {
  yearsDifference: number
  monthsDifference: number
  daysDifference: number
  hoursDifference: number
  minutesDifference: number
  secondsDifference: number
}

/**
 *
 * @param date1 The first Date
 * @param date2 The second Date
 * @returns The absolute time difference between the 2 dates in units between seconds and years
 */
export function getTimeDifference(date1: Date, date2: Date): TimeDifference {
  const [earlierDate, laterDate] =
    date2.getTime() > date1.getTime() ? [date1, date2] : [date2, date1]

  const difference = laterDate.getTime() - earlierDate.getTime()

  let monthsDifference =
    (laterDate.getFullYear() - earlierDate.getFullYear()) * 12

  const dayInMonthDifference = laterDate.getDate() - earlierDate.getDate()
  monthsDifference -= earlierDate.getMonth()
  monthsDifference += laterDate.getMonth()
  monthsDifference =
    dayInMonthDifference >= 0 ? monthsDifference : monthsDifference - 1

  const yearsDifference = Math.floor(monthsDifference / 12)

  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24)

  const hoursDifference = Math.floor(difference / 1000 / 60 / 60)

  const minutesDifference = Math.floor(difference / 1000 / 60)

  const secondsDifference = Math.floor(difference / 1000)

  return {
    yearsDifference,
    monthsDifference,
    daysDifference,
    hoursDifference,
    minutesDifference,
    secondsDifference
  }
}
